import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import { UsersContext } from '../../contexts/Users';
import { ITEM_STATUS } from '../../models/Completion';
import StarSVG from '../../svgs/StarSVG.js';
import Error from '../common/Error.js';
import CompleteNote from '../common/CompleteNote';
import EvidenceList from '../common/EvidenceList.js';
import MarkItemChecked from '../common/MarkItemChecked';
import StatusLight from '../common/StatusLight';
import SummativeComment from '../common/SummativeComment';
import MessageForm from '../messaging/MessageForm';
import * as CSS from './elements/PersonalTarget';

const PersonalTarget = observer(({ targetId }) => {
  const usersStore = useContext(UsersContext);
  const loggedInUser = usersStore.getLoggedInUser();
  const target = loggedInUser.private.personalTargets.get(targetId);

  if (!target) return <Error msg="Target not found" />;

  const evidence = loggedInUser.private.getEvidenceByTargetId(target.targetId);
  const status = loggedInUser.private.getItemStatus(
    targetId,
    'personalTargets'
  );
  const completion = loggedInUser.private.getItemCompletion(targetId);
  // completed work is read only for students until a teacher reopens it
  const isComplete = status === ITEM_STATUS.complete;

  return (
    <div data-testid="PersonalTarget">
      <CSS.StudentHeaderRow>
        <CSS.CenterLink to="/targets">
          <StarSVG />
          <CSS.TargetHeader>My Targets</CSS.TargetHeader>
        </CSS.CenterLink>
      </CSS.StudentHeaderRow>
      <CSS.EvidenceContainer>
        <MarkItemChecked
          student={loggedInUser}
          itemId={targetId}
          collection="personalTargets"
        />
        <CSS.TargetLi as="p" complete={status === ITEM_STATUS.complete}>
          {target.targetText}
        </CSS.TargetLi>
        <StatusLight status={status} itemId={targetId} />
        {status === ITEM_STATUS.complete && (
          <SummativeComment
            summary={completion.summary}
            heading="Your teacher's summary"
          />
        )}
        {evidence.length > 0 && (
          <EvidenceList
            evidence={evidence}
            resource="target"
            studentId={loggedInUser.id}
            targetId={target.targetId}
            isLocked={isComplete}
          />
        )}
        {isComplete ? (
          <CompleteNote resource="target" />
        ) : (
          <MessageForm targetId={targetId} />
        )}
      </CSS.EvidenceContainer>
    </div>
  );
});

export default PersonalTarget;
